var m = require('mithril');
var prop = require("mithril/stream");
var moment = require('moment-timezone');
var loaders = require('../../layout/components/loaders');
var modal = require('../../layout/components/modal');
var alerts = require('../../layout/components/alerts');
var key = require('../../libs/keybindings');
var Model = require('../../libs/Model');
var pagination = require('../../data/components/pagination');
var dragscroll = require('../../libs/dragscroll');
var session = require('../../auth/models/session');
var Comment = Object.create(Model);
var CommentModel = require('../../../../../models/comments/Comment');

Object.assign(Comment, CommentModel);
var dateFormat = 'MM/DD/YYYY HH:mm';

//var AlarmCommentModal = {};

modal.once('closed', function () {
  key.deleteScope('modal');
  key.setScope('home');
});

var modelOptions = {
  extrawidth: true
}

Comment.editDialogue = function (record, options) {
  delete Comment.record;
  delete Comment.comments;
  Comment.options = options || {};
  Comment.subjectRid = record && record['@rid'];

  Comment.comment = prop('');
  Comment.editingRid = prop(null);
  Comment.reinitializePagination = prop(false);
  Comment.comments = [];
  Comment.pendingDeleteRecord = null;
  Comment.updateButtons();

  Comment.getComments = () => {
    if (!Comment.subjectRid) return;
    loaders.requestWithLoader({
      url: `/api/v1/comment/subject/${Comment.subjectRid.slice(1)}`,
      method: "GET",
    })
    .then(function (result) {
      Comment.comments = (result || []).filter(r => !r.deleted);
      Comment.reinitializePagination(true);
      m.redraw();
    });
  };

  Comment.getComments();

  key.setScope('modal');
  modal.vm.title('Add comment: ');
  modal.vm.body = Comment.view;
  modal.vm.open(modelOptions);
}

Comment.isOwner = function (commentRecord) {
  if (!commentRecord) return false;
  const currentUserRid = session.user && session.user()['@rid'];
  const authorRid = commentRecord.userRid || (commentRecord.user && commentRecord.user['@rid']);
  return currentUserRid && authorRid && currentUserRid === authorRid;
};

Comment.isSuperUser = function () {
  const user = session.user && session.user();
  return !!(user && (user.isSuperuser === true || user.isSuperuser === 1 || user.isSuperuser === '1'));
};

Comment.canDelete = function (commentRecord) {
  return Comment.isSuperUser() && Comment.isOwner(commentRecord);
};

Comment.getEditingRecord = function () {
  const rid = Comment.editingRid && Comment.editingRid();
  if (!rid) return null;
  return Comment.comments.find(c => c['@rid'] === rid) || null;
};

Comment.updateButtons = function () {
  const isEditing = Comment.editingRid && Comment.editingRid();
  const buttons = [
    {
      label: 'Submit',
      class: `dib green`,
      func: function () { return Comment.submitComment(); }
    }
  ];

  if (isEditing) {
    buttons.unshift({
      label: 'Delete',
      class: 'dib mr2 red',
      func: function () { return Comment.confirmDelete(); }
    });
    buttons.unshift({
      label: 'Cancel',
      class: 'dib mr2',
      func: function () {
        Comment.resetForm();
        m.redraw();
      }
    });
  }

  modal.vm.buttons(buttons);
};

Comment.restoreMainView = function () {
  modal.vm.title('Add comment: ');
  modal.vm.body = Comment.view;
  Comment.updateButtons();
  modal.vm.open(modelOptions);
};

Comment.confirmDelete = function () {
  const targetRecord = Comment.pendingDeleteRecord || Comment.getEditingRecord();
  if (!targetRecord) return;
  Comment.pendingDeleteRecord = targetRecord;

  modal.vm.title('Delete comment?');
  modal.vm.body = Comment.confirmDeleteView;
  modal.vm.buttons([
    {
      label: 'Cancel',
      class: 'dib mr2',
      func: function () {
        Comment.pendingDeleteRecord = null;
        Comment.restoreMainView();
      }
    },
    {
      label: 'Delete',
      class: 'dib red',
      func: function () {
        const targetRecord = Comment.pendingDeleteRecord;
        if (!targetRecord || !targetRecord['@rid'] || !Comment.canDelete(targetRecord)) {
          Comment.pendingDeleteRecord = null;
          Comment.restoreMainView();
          m.redraw();
          return;
        }

        const deleteAction = Comment.delete(targetRecord);

        if (deleteAction && typeof deleteAction.then === 'function') {
          return deleteAction.then(function () {
            Comment.finishDelete(targetRecord);
            Comment.restoreMainView();
          });
        }
        Comment.finishDelete(targetRecord);
        Comment.restoreMainView();
      }
    }
  ]);
  modal.vm.open(modelOptions);
};

Comment.confirmDeleteView = function () {
  const record = Comment.pendingDeleteRecord || Comment.getEditingRecord();
  const message = record && record.message ? record.message : '';
  return m('div', [
    m('p', 'Are you sure you want to delete this comment?'),
    message ? m('div.mt3.pa2.br2.ba.b--dashed.b--dark-gray.bg-near-black', [
      m('div.white', message)
    ]) : null
  ]);
};

Comment.resetForm = function () {
  Comment.comment('');
  Comment.editingRid(null);
  Comment.pendingDeleteRecord = null;
  Comment.updateButtons();
};

Comment.finishDelete = function (targetRecord) {
  const rid = targetRecord && targetRecord['@rid'];
  if (rid) {
    Comment.comments = Comment.comments.filter(c => c['@rid'] !== rid);
  }
  Comment.resetForm();
  Comment.getComments();
  Comment.options && Comment.options.submitCallback ? Comment.options.submitCallback() : null;
  Comment.reinitializePagination(true);
  m.redraw();
};

Comment.submitComment = function () {
  const message = (Comment.comment() || '').trim();
  if (!message) {
    alerts.vm.add({ detail: 'Comment can´t be blank' });
    return;
  }
  if (!Comment.subjectRid) return;

  const editingRid = Comment.editingRid && Comment.editingRid();
  if (editingRid) {
    return loaders.requestWithLoader({
      url: `/api/v1/comment/${editingRid.toString().replace('#', '')}`,
      method: 'PUT',
      body: { message, updatedTimestamp: Date.now(), elementRid: 'alarms-table' }
    }).then(function () {
      Comment.resetForm();
      Comment.getComments();
      Comment.options && Comment.options.submitCallback ? Comment.options.submitCallback() : null;
      m.redraw();
    });
  }

  var record = {
    subjectRecord: Comment.subjectRid,
    timestamp: Date.now(),
    message: message,
    user: {
      firstName: session.user && session.user().firstName,
      lastName: session.user && session.user().lastName
    },
    userRid: session.user && session.user()['@rid'],
    elementRid: 'alarms-table'
  };
  Comment.comments = [record].concat(Comment.comments);
  Comment.reinitializePagination(true);
  m.redraw();
  return loaders.requestWithLoader({
    url: "/api/v1/comment",
    method: "POST",
    body: record,
  })
  .then(function (data) {
    Comment.resetForm();
    Comment.options && Comment.options.submitCallback ? Comment.options.submitCallback(data) : null;
    Comment.getComments();
  })
  .catch(function (e) {
    alerts.vm.add({detail: e});
    console.log(e);
  });
};

Comment.editComment = function (commentRecord) {
  if (!Comment.isOwner(commentRecord)) return;
  Comment.editingRid(commentRecord['@rid']);
  Comment.comment(commentRecord.message || '');
  Comment.updateButtons();
};

Comment.deleteComment = function (commentRecord) {
  const targetRecord = commentRecord || Comment.getEditingRecord();
  if (!targetRecord || !Comment.canDelete(targetRecord)) return;
  if (!targetRecord['@rid']) return;
  return Comment.delete(targetRecord).then(function () {
    Comment.finishDelete(targetRecord);
  });
};

Comment.view = function () {
  if (!Comment.comments) {
    return m('div')
  }

  return m('div.w-100', {
      style: { display: Comment.reinitializePagination() ? 'none' : '' }
    }, [
      m('div.overflow-hidden.mb3',  [
      m('div.dragscroll-container.w-100', [
        m('div.dragscroll.pb3', { oncreate: dragscroll }, [
          m('table.f3.bg-dark-gray.w-100', { style: { minWidth: '950px', tableLayout: 'fixed' } }, [
            m('thead', [
              m('tr.relative', [
                m('th.br.tl.bt-0.bl-0.b--dotted.bw1.w-50', { style: { minWidth: '400px' } }, 'Comment'),
                m('th.br.tl.bt-0.bl-0.b--dotted.bw1.w-20', { style: { minWidth: '200px' } }, 'By'),
                m('th.br.tl.bt-0.bl-0.b--dotted.bw1.w-20', { style: { minWidth: '200px' } }, 'Time'),
                m('th.br.tc.bt-0.bl-0.b--dotted.bw1.w-10', { style: { minWidth: '150px' } }, 'Actions')
              ]),
            ]),
              m('tbody', [
                Comment.comments.map(function (commentRecord) {
                  return m('tr', [
                    m('td.bb.tl.moon-gray.tl.w-50', { style: { wordWrap: 'break-word', minWidth: '400px' } }, commentRecord.message),
                    m('td.bb.tl.moon-gray.tl.w-20', { style: { minWidth: '200px' } }, ((commentRecord.user && commentRecord.user.firstName) || '') + " " + ((commentRecord.user && commentRecord.user.lastName) || '')),
                    m('td.bb.tl.moon-gray.tl.w-20', { style: { minWidth: '200px' } }, [
                      m('div', 'Created: ' + moment(new Date(commentRecord.timestamp)).format(dateFormat)),
                      commentRecord.updatedTimestamp
                        ? m('div.f6.moon-gray.mt1', 'Updated: ' + moment(new Date(commentRecord.updatedTimestamp)).format(dateFormat))
                        : null
                    ]),
                    m('td.bb.tl.moon-gray.tc.w-10', { style: { minWidth: '150px' } }, [
                      Comment.isOwner(commentRecord) ?
                        m('i.pointer.blue.ion-ios-compose.f1', {
                          title: 'Edit comment',
                          onclick: function () { Comment.editComment(commentRecord); }
                        })
                      : null,
                      Comment.canDelete(commentRecord) ?
                        m('i.pointer.red.ion-trash-b.f1.ml3', {
                          title: 'Delete comment',
                          onclick: function () {
                            Comment.pendingDeleteRecord = commentRecord;
                            Comment.confirmDelete();
                          }
                        })
                      : null
                    ]),
                  ])
                })
            ])
          ])
        ])
      ])
    ]),
    m(pagination, { data: Comment.comments, reinitializePagination: Comment.reinitializePagination }),
    m('form.mt4', [
      m('label', { for: 'comment' }, Comment.editingRid && Comment.editingRid() ? 'Edit comment' : 'New Comment:'),
      m('div.mt2', [
        m('textarea', {
          resize: 'none',
          id: 'comment',
          rows: '5',
          cols: '40',
          'box-sizing': 'border-box',
          placeholder: "Add your comment here...",
          oninput: function (ev) { Comment.comment(ev.target.value) },
          value: Comment.comment()
        })
      ])
    ])
  ])
}
module.exports = Comment;
